import React from "react";
import { Button, FormGroup, Input, Label } from "reactstrap";
import { getLegendUrl } from "./layers";

function ExplorerSidebar({
  description,
  species = [],
  isExploring,
  marker,
  bufferKm,
  activeLayers = [],
  selectedSpecies = [], // Add this prop
  onStartExploring,
  onCancelExploring,
  onToggleLayer,
}) {
  const isReadyForLayers = Boolean(marker);

  return (
    <div className="explorer-sidebar">
      {!isReadyForLayers && (
        <>
          <h5 className="mb-2">About this Explorer</h5>
          <p className="sidebar-text">{description}</p>
          <h6 className="mt-3">Species Covered ({species.length})</h6>
          <div className="sidebar-list">
            {species.map((sp) => (
              <div key={sp.sci_name} className="sidebar-list-item">
                <span>{sp.local_name} <i>({sp.sci_name})</i></span>
              </div>
            ))}
          </div>
          <Button color="success" className="mt-3" onClick={onStartExploring}>
            Start Exploring
          </Button>
        </>
      )}

      {isExploring && !isReadyForLayers && (
        <p className="mt-2 sidebar-hint">Click on the map to drop a point.</p>
      )}

      {isReadyForLayers && (
        <>
          <h5 className="mb-2">Selection</h5>
          <p className="sidebar-text">
            Location: {marker.lat.toFixed(4)}, {marker.lng.toFixed(4)}
            <br />
            Buffer: {bufferKm} km
          </p>

          <h6 className="mt-3">
            Layers <small>({selectedSpecies.length} selected)</small>
          </h6>
          <div className="sidebar-list">
            {species.map((layer) => {
              // Use selectedSpecies prop instead of activeLayers check
              const checked = selectedSpecies.includes(layer.sci_name);
              return (
                <FormGroup switch key={layer.sci_name} className="sidebar-switch">
                  <Input
                    type="switch"
                    role="switch"
                    checked={checked}
                    onChange={() => onToggleLayer(layer)}
                  />
                  <Label check>
                    {layer.local_name} <i>({layer.sci_name})</i>
                    {checked && <span className="ms-1">✓</span>}
                  </Label>
                </FormGroup>
              );
            })}
          </div>

          {activeLayers.length > 0 && (
            <>
              <h6 className="mt-3">Legend</h6>
              <div className="legend-list">
                {activeLayers.map((layer) => (
                  <div key={layer.sci_name} className="legend-item">
                    <span className="legend-title">{layer.local_name}</span>
                    <img 
                      alt={`${layer.local_name} legend`} 
                      className="legend-image" 
                      src={getLegendUrl(layer.id)} 
                    />
                  </div>
                ))}
              </div>
            </>
          )}

          <div className="mt-3 d-flex gap-2">
            <Button color="secondary" outline onClick={onCancelExploring}>
              Reset
            </Button>
            {selectedSpecies.length > 0 && (
              <Button color="info" onClick={() => {/* Optional: Add download or share */}}>
                Export ({selectedSpecies.length} layers)
              </Button>
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default ExplorerSidebar;